export default __webpack_public_path__ + "static/media/Fabpiks.332173f3.png";